module.exports = __webpack_public_path__ + "static/avatar-afc252460e2b783286e57514ccd4766e.jpg";